/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  // IGV T&P Custom PDP Selectors
  if (document.querySelector('input[name="igv-selector"]')) {
    document.querySelectorAll('input[name="igv-selector"]').forEach((elem) => {
      elem.addEventListener("click", function(event) {
        var item = event.target.value;

        if (item == '1-onetime') {
          if(document.querySelector('.select-popout__option[data-value*="ndividual"]')){
            document.querySelector('.select-popout__option[data-value*="ndividual"]').click();
            document.querySelector('input[name="selling-plan-group"][value=""]').click();
          }else if(document.querySelector('.select-popout__option[data-value*="1 tin"]')){
            document.querySelector('.select-popout__option[data-value*="1 tin"]').click();
            document.querySelector('input[name="selling-plan-group"][value=""]').click();
          }
        } else if (item == '3-onetime') {
          if(document.querySelector('.select-popout__option[data-value*="uarterly"]')){
            document.querySelector('.select-popout__option[data-value*="uarterly"]').click();
            document.querySelector('input[name="selling-plan-group"][value=""]').click();
          }else if(document.querySelector('.select-popout__option[data-value*="3 bottles"]')){
            document.querySelector('.select-popout__option[data-value*="3 bottles"]').click();
            document.querySelector('input[name="selling-plan-group"][value=""]').click();
          }else if(document.querySelector('.select-popout__option[data-value*="3 tins"]')){
            document.querySelector('.select-popout__option[data-value*="3 tins"]').click();
            document.querySelector('input[name="selling-plan-group"][value=""]').click();
          }
          
        } else {// Subscription
          if(document.querySelector('.select-popout__option[data-value*="uarterly"]')){
            document.querySelector('.select-popout__option[data-value*="uarterly"]').click();
          }else if(document.querySelector('.select-popout__option[data-value*="3 bottles"]')){
            document.querySelector('.select-popout__option[data-value*="3 bottles"]').click();
          }else if(document.querySelector('.select-popout__option[data-value*="3 tins"]')){
            document.querySelector('.select-popout__option[data-value*="3 tins"]').click();
          }else{
            document.querySelector('.select-popout__option[data-value*="uarterly"]').click();
          }
          document.querySelector('input[name="selling-plan-group"]:not([value=""])').click();
        }

      });
    });

    // Initial state
    var is_individual = document.querySelector('[name="options[Size]"]').value.toLowerCase().includes('individual');
    var is_subscription = document.querySelector('input[name="selling-plan-group"]:not([value=""]):checked') !== null;
    if (is_subscription) {
      document.querySelector('input[name="igv-selector"][value="3-subscription"]').checked = true;
    } else if (!is_individual) {
      document.querySelector('input[name="igv-selector"][value="3-onetime"]').checked = true;
    } else {
      document.querySelector('input[name="igv-selector"][value="1-onetime"]').checked = true;
    }
    
  }


  // Product Added to Cart Event
  document.addEventListener('theme:cart:popdown', (e) => {
    var conversion_value = 1;
    if (typeof e.detail.variant.final_price != undefined) {
      conversion_value = e.detail.variant.final_price / 100;
    }
    gtag('event', 'conversion', {
        'send_to': 'AW-11014545972/4ICuCLuy9oQYELTEkoQp',
        'value': conversion_value,
        'currency': 'USD'
    });
  });

  // Quick Add to cart CTA (Physican product tiles)
  document.querySelectorAll('[data-quick-add-variant]').forEach((elem) => {
    elem.addEventListener("click", function(event) {
      var variantID = elem.dataset.quickAddVariant;
      elem.classList.add('loading');
      
      themeVendor.axios({
        method: 'post',
        url: '/cart/add.js',
        data: { 
          id: variantID,
          quantity: 1
        }
      })
      .then( (response) => {
        document.dispatchEvent(new CustomEvent('theme:cart:init', {bubbles: true}));
        setTimeout(function() {
          document.querySelector('[data-drawer-toggle="drawer-cart"]').click();
        }, 1000);
        setTimeout(function() {
          elem.classList.remove('loading');
        }, 1500);
      })
      .catch( (error) => {
        console.error('Error:', error);
        elem.classList.remove('loading');
      });
        
        
        
    });
  });
  
  

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });


  // Buy Now functionality for Holiday Gift Set (ONLY applies to products with data-buy-now-product="true")
  // This product does NOT have data-add-to-cart attribute, so theme won't intercept it
  document.addEventListener('DOMContentLoaded', function() {
    const buyNowButton = document.querySelector('[data-buy-now-product="true"]');

    if (buyNowButton) {
      const form = buyNowButton.closest('form');

      // Handle form submit for Buy Now
      form.addEventListener('submit', function(event) {
        event.preventDefault();

        // Get form data
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        const sellingPlanId = formData.get('selling_plan');

        // Check if variant is available
        if (!variantId || buyNowButton.disabled) {
          return;
        }

        // Show loading state
        buyNowButton.classList.add('btn--loading');
        buyNowButton.disabled = true;

        // Prepare cart data
        const cartData = {
          items: [{
            id: parseInt(variantId),
            quantity: parseInt(quantity)
          }]
        };

        // Add selling plan if exists
        if (sellingPlanId) {
          cartData.items[0].selling_plan = parseInt(sellingPlanId);
        }

        // Add to cart and redirect to checkout
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(cartData)
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          return response.json();
        })
        .then(function(data) {
          // Redirect to checkout immediately
          window.location.href = '/checkout';
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          buyNowButton.classList.remove('btn--loading');
          buyNowButton.disabled = false;

          // Show error message
          const errorDiv = form.querySelector('[data-add-action-errors]');
          if (errorDiv) {
            errorDiv.innerHTML = '<p>There was an error processing your request. Please try again.</p>';
          }
        });
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
